
export default {
  exportFields: state => state.exportFields,
  fileFormat: state => state.fileFormat,
  fileFormats: state => state.fileFormats,
  fileFormatsFilters: state => state.fileFormatsFilters,
  fileFormatsCurrentPage: state => state.fileFormatsCurrentPage,
  fileFormatsLastPage: state => state.fileFormatsLastPage,
  fieldMapping: state => state.fieldMapping,
  fieldsMapping: state => state.fieldsMapping,
  fieldsMappingFilters: state => state.fieldsMappingFilters,
  fieldsMappingCurrentPage: state => state.fieldsMappingCurrentPage,
  fieldsMappingLastPage: state => state.fieldsMappingLastPage,
  erps: state => state.erps
}
